<script setup lang="ts">
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import { DraggerType, type DimensionKind } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";

/** Cote : ce qu'elle mesure (distance, X ou Y), toujours placée en 2 points. */
const KINDS: { kind: DimensionKind; icon: string }[] = [
  { kind: "aligned", icon: "arrows-out-simple" },
  { kind: "horizontal", icon: "arrows-horizontal" },
  { kind: "vertical", icon: "arrows-vertical" },
];
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Dimension]">
    <template #tool>
      <Dragger
        :config="{ name: DraggerType.Dimension }"
        phosphor-icon="arrows-out-line-horizontal"
        :tooltip-text="$t('canvas:tools.dimension.tooltip.text')"
        :tooltip-title="$t('canvas:tools.dimension.tooltip.title')"
        @click="
          DraggerMenuState.setActiveDragger({ name: DraggerType.Dimension })
        "
      />
    </template>
    <div
      class="btn-group-vertical rounded p-1"
      style="background-color: var(--canvas-bg)"
    >
      <DisableToolBtn v-if="!Settings.onlyStylusOn" />
      <CanvasButton
        v-for="{ kind, icon } in KINDS"
        :key="kind"
        :phosphor-icon="icon"
        :tooltip-title="$t(`canvas:tools.dimension.kinds.${kind}.title`)"
        :tooltip-text="$t(`canvas:tools.dimension.kinds.${kind}.text`)"
        :mode="DraggerMenuState.dimensionKind === kind"
        @click.prevent.stop="DraggerMenuState.setDimensionKind(kind)"
      />
    </div>
  </ToolOptionsDropdown>
</template>
